import apiClient from '../config/api';

const paymentService = {
  /**
   * Initiate payment
   * @param {object} paymentData - Payment initiation data
   * @returns {Promise} Payment initiation response with payment URL
   */
  initiatePayment: async (paymentData) => {
    const response = await apiClient.post('/payment/initiate', paymentData);
    return response.data;
  },

  /**
   * Check payment status
   * @param {string} merchantTransactionId - Merchant transaction ID
   * @returns {Promise} Payment status
   */
  checkPaymentStatus: async (merchantTransactionId) => {
    const response = await apiClient.get(`/payment/status/${merchantTransactionId}`);
    return response.data;
  },

  /**
   * Handle payment callback
   * @param {object} callbackData - Payment callback data
   * @returns {Promise} Callback processing result
   */
  handlePaymentCallback: async (callbackData) => {
    const response = await apiClient.post('/payment/callback', callbackData);
    return response.data;
  },

  /**
   * Complete payment
   * @param {object} completionData - Payment completion data
   * @returns {Promise} Payment completion result
   */
  completePayment: async (completionData) => {
    const response = await apiClient.post('/payment/complete', completionData);
    return response.data;
  },
};

export default paymentService;

